import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormErrorMessage from '../../messages/FormErrorMessage';
import { InputNumber, InputNumberProps } from 'primereact/inputnumber';
import { getFieldArrayError } from '@/src/utils/formUtils';

type FormControlledNumberInputProps = InputNumberProps & {
  defaultValue?: number;
  formID: string;
  rules?: object;
  isFieldArray?: boolean;
  onChange?: (amount: number) => void;
};

const FormControlledNumberInput = ({
  defaultValue,
  formID,
  rules,
  isFieldArray,
  onChange,
  ...otherProps
}: FormControlledNumberInputProps) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  let fieldError = errors[formID];
  if (isFieldArray) {
    fieldError = getFieldArrayError(formID, errors);
  }

  return (
    <React.Fragment>
      <Controller
        defaultValue={defaultValue}
        control={control}
        name={formID}
        rules={rules}
        render={({
          field: {
            ref,
            onChange: rhfChange,
            onBlur: fieldOnBlur,
            ...otherFields
          },
        }) => (
          <InputNumber
            id={formID}
            inputRef={ref}
            className={`w-full ${fieldError && 'p-invalid'}`}
            inputClassName="w-full blackText text-standard"
            onValueChange={(e) => {
              rhfChange(e.value);
            }}
            {...otherProps}
            {...otherFields}
            onBlur={(e) => {
              fieldOnBlur();
              otherProps.onBlur?.(e);
            }}
            onKeyDown={(event) => {
              if (
                event.code === 'Minus' &&
                !!otherFields.value &&
                otherFields.value > 0
              ) {
                setValue(formID, -1 * otherFields.value);

                if (onChange) {
                  onChange(-1 * otherFields.value);
                }
              }
            }}
            onChange={(e) => {
              if (onChange) {
                onChange(e.value ?? 0);
              }
            }}
          />
        )}
      />
      {fieldError && (
        <FormErrorMessage errorMessage={fieldError.message as string} />
      )}
    </React.Fragment>
  );
};

export default FormControlledNumberInput;
